import React from 'react'
import ButtonWithLoader from './ButtonWithLoader'
import Microphone from '../icons/Microphone'
import LessonIcon from './LessonIcon'
import Speaker from '../icons/Speaker'
import LessonClock from './LessonClock'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import { TOGGLE_CAMERA, TOGGLE_MICROPHONE, TOGGLE_SPEAKER } from '../redux/lessonToolsReducer'
import Camera from '../icons/Camera'
import Logo from '../icons/Logo'
import LessonSetting from './LessonSetting'

type Props = {}

const LessonHeader = (props: Props) => {
  const dispatch = useDispatch()
  const microphoneEnabled = useSelector((state: RootReducer) => state.lessonToolsReducer.microphoneEnabled)
  const cameraEnabled = useSelector((state: RootReducer) => state.lessonToolsReducer.cameraEnabled)
  const speakerEnabled = useSelector((state: RootReducer) => state.lessonToolsReducer.speakerEnabled)

  return (
    <div className="bg-slateGray border-b-2 border-slateGray p-3 flex">
      <div className="flex-1" />
      <div className="flex items-center">
        <div className="w-14 h-14 text-darkRed">
          <Logo />
        </div>
        <div className="text-white text-28 font-domine">Fluent Future</div>
      </div>
      <div className="flex-1 flex justify-end items-center">
        <LessonClock />
        <div className="w-[1rem]" />
        <LessonSetting />
        <div className="w-[1rem]" />
        <LessonIcon onClick={() => dispatch(TOGGLE_SPEAKER())} active={!speakerEnabled} icon={<Speaker />} />
        <div className="w-[1rem]" />
        <LessonIcon onClick={() => dispatch(TOGGLE_MICROPHONE())} active={!microphoneEnabled} icon={<Microphone />} />
        <div className="w-[1rem]" />
        <LessonIcon onClick={() => dispatch(TOGGLE_CAMERA())} active={!cameraEnabled} icon={<Camera />} />
        <div className="w-[1rem]" />
        <div className="w-[10rem]">
          <ButtonWithLoader color="darkRed" label="Leave" onClick={() => {}} />
        </div>
      </div>
    </div>
  )
}

export default LessonHeader
